export default function svgImageIcon(classes) {
	return (
		<svg
			className={classes}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18 3.25H6C3.582 3.25 2.25 4.582 2.25 7V17C2.25 19.418 3.582 20.75 6 20.75H18C20.418 20.75 21.75 19.418 21.75 17V7C21.75 4.582 20.418 3.25 18 3.25ZM6 4.75H18C19.577 4.75 20.25 5.423 20.25 7V13.189L16.24 9.17993C15.58 8.51893 14.42 8.51893 13.76 9.17993L9 13.939L8.23999 13.1799C7.57999 12.5189 6.42001 12.5189 5.76001 13.1799L3.75 15.1899V7C3.75 5.423 4.423 4.75 6 4.75ZM18 19.25H6C4.528 19.25 3.85197 18.654 3.76697 17.293L6.81995 14.24C6.94695 14.114 7.05196 14.114 7.17896 14.24L8.11804 15.179C8.58504 15.647 9.41403 15.646 9.87903 15.179L14.819 10.239C14.946 10.113 15.051 10.113 15.178 10.239L20.248 15.3091V17C20.25 18.577 19.577 19.25 18 19.25ZM6.75 9C6.75 8.31 7.31 7.75 8 7.75C8.69 7.75 9.25 8.31 9.25 9C9.25 9.69 8.69 10.25 8 10.25C7.31 10.25 6.75 9.69 6.75 9Z"
				fill="currentColor"
			/>
		</svg>
	);
}
